import type { LucideIcon } from "lucide-react";
import {
  Building2,
  Gauge,
  PlugZap,
  UserRoundCog,
} from "lucide-react";

export type SettingsSectionId =
  | "team"
  | "account"
  | "clinic"
  | "autonomy"
  | "usage"
  | "automations"
  | "integrations";

export type SettingsSection = {
  id: SettingsSectionId;
  title: string;
  url: string;
  icon: LucideIcon;
};

/**
 * Unconditional settings destinations. ACCESS-01 (2026-09-30) groups legacy
 * business URLs under clinic; SettingsLayout inserts the team destination
 * only with users/profile read access. Each destination retains this chrome.
 * AI configuration stays in the team workspace; legacy AI URLs remain aliases.
 */
export const SETTINGS_SECTIONS: SettingsSection[] = [
  {
    id: "account",
    title: "Conta pessoal",
    url: "/settings/account",
    icon: UserRoundCog,
  },
  {
    id: "clinic",
    title: "Clínica",
    url: "/settings/clinic",
    icon: Building2,
  },
  {
    id: "integrations",
    title: "Canais",
    url: "/settings/integrations",
    icon: PlugZap,
  },
  {
    id: "usage",
    title: "Plano e consumo",
    url: "/settings/usage",
    icon: Gauge,
  },
];

/** Maps a legacy `/account-settings` query to the section that replaced it. */
export function legacySettingsRedirect(search: string): string {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const page = params.get("page");

  if (page === "platform-settings") return "/settings/integrations";

  switch (tab) {
    case "platforms":
    case "integrations":
      return "/settings/integrations";
    case "autonomy":
      return "/settings/autonomy";
    case "clinic":
      return "/settings/clinic";
    case "ai-studio":
    case "automations":
      return "/settings/automations";
    case "account":
    case "notification":
    default:
      return "/settings/account";
  }
}
